import GenericTool from '../tools/GenericTool';
import { type ChatMessagePart, isActiveToolPart } from './utils';

type Props = {
  isDebug: boolean;
  isStreaming: boolean;
  part: ChatMessagePart;
};

const ToolDebugPart = ({ isDebug, isStreaming, part }: Props) => {
  if (!isDebug && isActiveToolPart(part)) return null;
  return <GenericTool part={part} isStreaming={isStreaming} />;
};

export default ToolDebugPart;
